// Shared collection product card interactions.
// Extracted from product grid snippets so the browser parses it once instead of once per product card.
(function() {
  if (window.__collectionProductCardScriptReady) return;
  window.__collectionProductCardScriptReady = true;

// ВАЖНО: Формы карточек коллекции НЕ имеют класс .product-single__form
  // Это предотвращает двойную инициализацию темой (theme.js строка 2878)
  // Вместо этого используем прямой API вызов через addToCartViaAPI()
  // 
  // Этот код работает ТОЛЬКО для карточек коллекций (.grid__item-collection)

  function switchImage(variantDiv) {
    if (!variantDiv) return;

    var gridItem = variantDiv.closest('.grid__item-collection');
    if (!gridItem) return;

    var variantId = variantDiv.dataset.variantId;
    var variantImage = variantDiv.dataset.variantImage;
    var variantPrice = variantDiv.dataset.price;
    var variantCompareAtPrice = variantDiv.dataset.compareAtPrice;
    if (!variantId) return;

    var mainImageWrapper = gridItem.querySelector('.grid__item-image-wrapper');
    if (!mainImageWrapper) return;

    // Убираем активный класс со всех вариантов в этой карточке
    gridItem.querySelectorAll('.variant-input-collection').forEach(function(variant) {
      variant.classList.remove('is-active');
      variant.classList.add('is-inactive');
    });

    // Добавляем активный класс к выбранному
    variantDiv.classList.add('is-active');
    variantDiv.classList.remove('is-inactive');

    // Обновляем скрытое поле в форме добавления в корзину
    var variantIdInput = gridItem.querySelector('[data-variant-id-input]');
    if (variantIdInput) {
      variantIdInput.value = variantId;
    }

    // Обновляем select (для совместимости со стандартной формой)
    var variantSelect = gridItem.querySelector('[data-product-select]');
    if (variantSelect) {
      variantSelect.value = variantId;
    }

    // Обновляем кнопку Add to Cart (доступность и текст)
    var addToCartBtn = gridItem.querySelector('[data-add-to-cart]');
    var addToCartText = gridItem.querySelector('[data-add-to-cart-text]');
    if (addToCartBtn && addToCartText) {
      var radioInput = variantDiv.querySelector('input[type="radio"]');
      var isAvailable = radioInput && !radioInput.disabled;
      
      if (isAvailable) {
        addToCartBtn.disabled = false;
        addToCartText.textContent = addToCartText.dataset.defaultText || 'Add to cart';
      } else {
        addToCartBtn.disabled = true;
        addToCartText.textContent = 'Sold out';
      }
    }

    // Обновляем цену на карточке
    if (variantPrice) {
      updateProductPrice(gridItem, variantPrice, variantCompareAtPrice);
    }

    // Меняем изображение если есть
    if (variantImage) {
      var mainImage = mainImageWrapper.querySelector('img');
      if (!mainImage) return;

      if (!mainImage.dataset.originalSrc) {
        mainImage.dataset.originalSrc = mainImage.src;
        mainImage.dataset.originalSrcset = mainImage.srcset || '';
      }

      mainImage.style.opacity = '0.5';
      mainImage.onload = function() {
        mainImage.style.opacity = '1';
      };
      mainImage.src = variantImage;
      mainImage.srcset = variantImage;

      if (mainImage.complete) {
        mainImage.style.opacity = '1';
      }
    }
  }

  function updateProductPrice(gridItem, price, compareAtPrice) {
    if (!gridItem || !price) return;

    var priceContainer = gridItem.querySelector('[data-product-price-container]');
    if (!priceContainer) return;

    var priceValue = parseInt(price);
    var compareValue = compareAtPrice ? parseInt(compareAtPrice) : 0;
    var hasDiscount = compareValue > priceValue;

    // Явный флаг состояния на самом контейнере — раньше цвет цены (красный
    // при скидке) определялся через CSS :has(.price-wrapp), а этот элемент
    // при смене варианта БЕЗ скидки не удалялся из DOM, а просто прятался
    // (display:none) — :has() видит структуру дерева, а не видимость,
    // поэтому красный цвет "залипал" на любом следующем варианте. Теперь
    // источник правды — явный атрибут, который меняется вместе с ценой.
    priceContainer.setAttribute('data-on-sale', hasDiscount ? 'true' : 'false');

    var formattedPrice = formatMoney(priceValue);
    var formattedCompare = compareValue > 0 ? formatMoney(compareValue) : '';

    var regularPriceEl = priceContainer.querySelector('[data-regular-price]');
    var priceFromEl = priceContainer.querySelector('[data-price-from]');
    var priceWrappEl = priceContainer.querySelector('[data-price-wrapp]');
    var comparePriceEl = priceContainer.querySelector('[data-compare-price]');
    var savingsEl = priceContainer.querySelector('[data-savings]');

    if (hasDiscount) {
      if (regularPriceEl) regularPriceEl.style.display = 'none';
      if (priceFromEl) priceFromEl.style.display = 'none';
      
      if (!regularPriceEl) {
        regularPriceEl = document.createElement('div');
        regularPriceEl.className = 'product-regular';
        regularPriceEl.setAttribute('data-regular-price', '');
        priceContainer.appendChild(regularPriceEl);
      }
      
      if (!priceWrappEl) {
        priceWrappEl = document.createElement('div');
        priceWrappEl.className = 'price-wrapp';
        priceWrappEl.setAttribute('data-price-wrapp', '');
        priceContainer.insertBefore(priceWrappEl, regularPriceEl);
      }
      priceWrappEl.style.display = '';

      if (!comparePriceEl) {
        comparePriceEl = document.createElement('span');
        comparePriceEl.className = 'grid-product__price--original';
        comparePriceEl.setAttribute('data-compare-price', '');
        priceWrappEl.appendChild(comparePriceEl);
      }
      comparePriceEl.textContent = formattedCompare;

      if (!savingsEl) {
        savingsEl = document.createElement('span');
        savingsEl.className = 'grid-product__price--savings';
        savingsEl.setAttribute('data-savings', '');
        priceWrappEl.appendChild(savingsEl);
      }
      var savedAmount = compareValue - priceValue;
      savingsEl.textContent = '-' + formatMoney(savedAmount);

      regularPriceEl.textContent = formattedPrice;
      regularPriceEl.style.display = '';
    } else {
      if (priceWrappEl) priceWrappEl.style.display = 'none';
      if (priceFromEl) priceFromEl.style.display = 'none';
      
      if (!regularPriceEl) {
        regularPriceEl = document.createElement('div');
        regularPriceEl.className = 'product-regular';
        regularPriceEl.setAttribute('data-regular-price', '');
        priceContainer.appendChild(regularPriceEl);
      }
      regularPriceEl.textContent = formattedPrice;
      regularPriceEl.style.display = '';
    }
  }

  function formatMoney(cents) {
    if (typeof cents === 'string') {
      cents = parseInt(cents);
    }
    
    // Use theme's formatMoney function to respect currency settings
    if (typeof theme !== 'undefined' && theme.Currency && theme.Currency.formatMoney) {
      var moneyFormat = theme.settings && theme.settings.moneyFormat ? theme.settings.moneyFormat : null;
      var result = theme.Currency.formatMoney(cents, moneyFormat);
      console.log('formatMoney - using theme.Currency:', { cents: cents, format: moneyFormat, result: result });
      return result;
    }
    
    // Fallback: try to use Shopify.formatMoney if available
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      var shopifyFormat = window.Currency && window.Currency.moneyFormats 
        ? window.Currency.moneyFormats[window.Currency.currentCurrency] 
        : null;
      if (shopifyFormat) {
        var result = Shopify.formatMoney(cents, shopifyFormat);
        console.log('formatMoney - using Shopify.formatMoney:', { cents: cents, format: shopifyFormat, result: result });
        return result;
      }
    }
    
    // Final fallback to simple formatting
    var value = (cents / 100).toFixed(2);
    var result = '€' + value.replace('.', ',');
    console.log('formatMoney - using fallback:', { cents: cents, result: result });
    return result;
  }

  if (!window.__collectionVariantSwitcherBound) {
    // Не перехватываем submit — даём Opus (и другим cart drawer app-ам) поймать его первыми.

    // Делегирование: работает и для карточек, добавленных после AJAX-фильтрации
    document.addEventListener('change', function(event) {
      if (!event.target.matches('.grid__item-collection .variant-input-collection input[type="radio"]')) return;

      var variantDiv = event.target.closest('.variant-input-collection[data-variant-id]');
      switchImage(variantDiv);
    });

    document.addEventListener('touchstart', function(event) {
      var label = event.target.closest('.grid__item-collection .variant-input-collection label');
      if (!label) return;

      var variantDiv = label.closest('.variant-input-collection[data-variant-id]');
      if (!variantDiv) return;

      var radioInput = variantDiv.querySelector('input[type="radio"]');
      if (!radioInput || radioInput.checked) return;

      radioInput.checked = true;
      switchImage(variantDiv);
    }, { passive: true });

    window.__collectionVariantSwitcherBound = true;
  }

  if (!window.__colorSwatchPopupBound) {
    document.addEventListener('click', function(e) {
      if (!e.target.matches('.color-swatch-more')) return;
      
      e.preventDefault();
      
      if (!window.matchMedia('(max-width: 767px)').matches) {
        const gridItem = e.target.closest('.grid__item-collection');
        const productUrl = gridItem?.querySelector('a[href*="/products/"]')?.href;
        if (productUrl) {
          window.location.href = productUrl;
        }
        return;
      }
      
      const btn = e.target;
      const gridItem = btn.closest('.grid__item-collection');
      const colorSwatchContainer = btn.closest('.grid-product__colors');
      
      if (!gridItem || !colorSwatchContainer) return;
      
      const allSwatches = colorSwatchContainer.querySelectorAll('.color-swatch, .color-swatch--hidden');
      const form = gridItem.querySelector('form[data-product-form]');
      const productId = btn.dataset.productId;
      
      if (window.openColorSwatchPopup) {
        window.openColorSwatchPopup(allSwatches, form, gridItem, productId);
      }
    });

    window.__colorSwatchPopupBound = true;
  }

  function openColorSwatchPopup(swatches, form, gridItem, productId) {
    const existingPopup = document.querySelector('.color-swatch-popup');
    if (existingPopup) {
      existingPopup.remove();
    }

    const popup = document.createElement('div');
    popup.className = 'color-swatch-popup';
    popup.innerHTML = `
      <div class="color-swatch-popup__overlay"></div>
      <div class="color-swatch-popup__content">
        <div class="color-swatch-popup__header">
          <h3>Select Color</h3>
          <button type="button" class="color-swatch-popup__close">&times;</button>
        </div>
        <div class="color-swatch-popup__body">
          ${Array.from(swatches).map(swatch => {
            const label = swatch.getAttribute('aria-label') || '';
            const colorValue = swatch.dataset.colorValue || '';
            const fullStyle = swatch.getAttribute('style') || '';
            const variantId = swatch.dataset.variantId;
            const variantImage = swatch.dataset.variantImage;
            const isAvailable = swatch.dataset.available === 'true';
            const price = swatch.dataset.price;
            const compareAtPrice = swatch.dataset.compareAtPrice;
            
            const bgMatch = fullStyle.match(/background[^;]*:[^;]+;?/gi);
            let swatchStyle = bgMatch ? bgMatch.join(' ') : '';
            if (!swatchStyle && fullStyle) {
              swatchStyle = fullStyle.replace(/display\s*:\s*none\s*;?/gi, '').trim();
            }
            
            let priceHtml = '';
            if (price) {
              try {
                const formattedPrice = formatMoney(price);
                
                if (compareAtPrice && parseInt(compareAtPrice) > parseInt(price)) {
                  const formattedCompare = formatMoney(compareAtPrice);
                  priceHtml = `<span class="variant-popup-price"><span class="variant-popup-price--compare">${formattedCompare}</span> <span class="variant-popup-price--sale">${formattedPrice}</span></span>`;
                } else {
                  priceHtml = `<span class="variant-popup-price">${formattedPrice}</span>`;
                }
              } catch (error) {
                console.error('Error formatting price in popup:', error);
                // Fallback to raw price display
                const rawPrice = (parseInt(price) / 100).toFixed(2);
                priceHtml = `<span class="variant-popup-price">${rawPrice}</span>`;
              }
            }
            
            return `
              <button type="button" class="color-swatch-popup__item ${!isAvailable ? 'is-unavailable' : ''}" 
                data-variant-id="${variantId || ''}"
                data-variant-image="${variantImage || ''}"
                data-available="${isAvailable}"
                data-href="${swatch.href || ''}">
                <span class="color-swatch-popup__swatch" style="${swatchStyle}"></span>
                <span class="color-swatch-popup__label">${label}</span>
                ${priceHtml}
              </button>
            `;
          }).join('')}
        </div>
        <div class="color-swatch-popup__footer">
          <button type="button" class="color-swatch-popup__add-to-cart btn btn--full">
            Add to Cart
          </button>
        </div>
      </div>
    `;

    document.body.appendChild(popup);
    document.body.style.overflow = 'hidden';

    setTimeout(() => popup.classList.add('is-open'), 10);

    const closePopup = () => {
      popup.classList.remove('is-open');
      document.body.style.overflow = '';
      setTimeout(() => popup.remove(), 300);
    };

    popup.querySelector('.color-swatch-popup__close').addEventListener('click', closePopup);
    popup.querySelector('.color-swatch-popup__overlay').addEventListener('click', closePopup);

    popup.querySelectorAll('.color-swatch-popup__item').forEach(item => {
      item.addEventListener('click', () => {
        if (item.classList.contains('is-unavailable')) {
          return;
        }
        
        popup.querySelectorAll('.color-swatch-popup__item').forEach(i => i.classList.remove('is-active'));
        item.classList.add('is-active');
        
        const variantImage = item.dataset.variantImage;
        const variantId = item.dataset.variantId;
        
        if (variantImage && gridItem) {
          const mainImageWrapper = gridItem.querySelector('.grid__item-image-wrapper');
          const mainImage = mainImageWrapper?.querySelector('img');
          
          if (mainImage) {
            if (!mainImage.dataset.originalSrc) {
              mainImage.dataset.originalSrc = mainImage.src;
              mainImage.dataset.originalSrcset = mainImage.srcset || '';
            }
            
            mainImage.style.opacity = '0.5';
            mainImage.onload = function() {
              mainImage.style.opacity = '1';
            };
            mainImage.src = variantImage;
            mainImage.srcset = variantImage;
            
            if (mainImage.complete) {
              mainImage.style.opacity = '1';
            }
          }
        }
        
        if (variantId && gridItem) {
          gridItem.dataset.selectedVariantId = variantId;
          
          const variantIdInput = gridItem.querySelector('[data-variant-id-input]');
          if (variantIdInput) {
            variantIdInput.value = variantId;
          }
          
          const variantSelect = gridItem.querySelector('[data-product-select]');
          if (variantSelect) {
            variantSelect.value = variantId;
          }
        }
      });
    });

    popup.querySelector('.color-swatch-popup__add-to-cart').addEventListener('click', () => {
      const activeItem = popup.querySelector('.color-swatch-popup__item.is-active:not(.is-unavailable)');
      let variantId = activeItem?.dataset.variantId;
      
      if (!variantId) {
        const firstAvailableItem = popup.querySelector('.color-swatch-popup__item:not(.is-unavailable)');
        if (firstAvailableItem) {
          firstAvailableItem.click();
          setTimeout(() => {
            popup.querySelector('.color-swatch-popup__add-to-cart').click();
          }, 100);
        }
        return;
      }
      
      if (activeItem?.classList.contains('is-unavailable')) {
        alert('This color is not available');
        return;
      }
      
      // Идём через сабмит формы (как variant-options-popup) —
      // это позволяет сторонним cart drawer app-ам (Opus Cart Upsell и т.п.),
      // подписанным на submit/click по button[name="add"], открыть свой drawer.
      // Сам add-to-cart выполняется обработчиком формы в .collection-product-form
      // (см. listener выше, который вызывает addToCartViaAPI).
      closePopup();
      addToCartViaForm(variantId, gridItem);
    });
  }

  function addToCartViaForm(variantId, gridItem) {
    // Каждая карточка коллекции теперь всегда содержит .collection-product-form
    // (скрытую для не-Volume товаров — см. product-grid-item.liquid).
    // Кликаем её submit-кнопку — тем же путём идёт рабочая variant-options-popup,
    // и Opus / другой cart drawer app, забиндившийся к этой форме на загрузке
    // страницы, поймает сабмит и откроет свой drawer.
    var form = gridItem && gridItem.querySelector('form.collection-product-form');
    if (!form) {
      addToCartViaAPI(variantId);
      return;
    }

    // Синхронизация выбранного варианта (как делает рабочий variant-options-popup):
    // input + select + radio варианта, с change-событиями — некоторые cart drawer
    // app-ы отслеживают change варианта, и без него используют изначальный.
    var gridItemForRadio = form.closest('.grid__item-collection') || gridItem;
    var variantRadio = gridItemForRadio && gridItemForRadio.querySelector(
      '.variant-input-collection[data-variant-id="' + variantId + '"] input[type="radio"]'
    );
    if (variantRadio && !variantRadio.checked) {
      variantRadio.checked = true;
      variantRadio.dispatchEvent(new Event('change', { bubbles: true }));
    }

    var idInput = form.querySelector('input[name="id"]');
    if (idInput) {
      idInput.value = variantId;
      idInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    var idSelect = form.querySelector('select[name="id"], [data-product-select]');
    if (idSelect) {
      idSelect.value = variantId;
      idSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }

    var submitBtn = form.querySelector('[data-add-to-cart]');
    if (!submitBtn) {
      addToCartViaAPI(variantId);
      return;
    }
    submitBtn.disabled = false;

    // Откладываем сабмит на следующий tick — это даёт cart drawer app-ам
    // (Opus Cart Upsell) обработать change-события варианта и завершить
    // текущий event loop перед submit. Без отложки на Volume-карточках
    // hover ATC не открывает Opus. Так же делает рабочий variant-options-popup.
    setTimeout(function() {
      submitBtn.click();
    }, 0);
  }

  function addToCartViaAPI(variantId, callback) {
    const formData = new FormData();
    formData.append('id', variantId);

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: {'X-Requested-With': 'XMLHttpRequest'}
    })
    .then(response => response.json())
    .then(data => {
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
        detail: { product: data },
        bubbles: true
      }));

      if (callback) callback();
    })
    .catch(error => {
      console.error('Error adding to cart:', error);
      if (callback) callback();
    });
  }

  // ── Клик по цветному свотчу (десктоп) — выбираем вариант вместо перехода ───
  // ЕДИНАЯ АРХИТЕКТУРА: раньше здесь была отдельная JS-инжектируемая
  // <style> и отдельная кнопка [data-hover-add-to-cart] со своим кликом
  // и своим addToCartViaForm — полностью отдельный от pill-вариантов путь.
  // Теперь цветной свотч обновляет РОВНО ТЕ ЖЕ поля единой формы
  // (.collection-add-to-cart-wrapper), что и выбор pill-варианта в
  // switchImage() выше — тот же hidden input, тот же select, та же
  // кнопка с обычным submit. Кнопка теперь всегда одна на карточку,
  // рендерится в шаблоне один раз, независимо от типа вариаций.
  if (!window.__colorSwatchDesktopHoverBound) {
    document.addEventListener('click', function(e) {
      if (window.matchMedia('(max-width: 767px)').matches) return;

      var swatch = e.target.closest('.grid__item-collection .grid-product__colors .color-swatch');
      if (!swatch) return;
      if (swatch.classList.contains('color-swatch--unavailable')) return;

      e.preventDefault();

      var gridItem = swatch.closest('.grid__item-collection');
      var colorsContainer = swatch.closest('.grid-product__colors');

      colorsContainer.querySelectorAll('.color-swatch').forEach(function(s) {
        s.classList.remove('is-hover-selected');
      });
      swatch.classList.add('is-hover-selected');

      var variantId = swatch.dataset.variantId;
      var variantImage = swatch.dataset.variantImage;
      var variantPrice = swatch.dataset.price;
      var variantCompareAtPrice = swatch.dataset.compareAtPrice;
      var isAvailable = swatch.dataset.available === 'true';

      if (variantId) {
        // Те же самые поля единой формы, что обновляет switchImage()
        // для pill-вариантов — один источник правды для обеих ситуаций.
        var variantIdInput = gridItem.querySelector('[data-variant-id-input]');
        if (variantIdInput) variantIdInput.value = variantId;

        var variantSelect = gridItem.querySelector('[data-product-select]');
        if (variantSelect) variantSelect.value = variantId;

        var addToCartBtn = gridItem.querySelector('[data-add-to-cart]');
        var addToCartText = gridItem.querySelector('[data-add-to-cart-text]');
        if (addToCartBtn && addToCartText) {
          if (isAvailable) {
            addToCartBtn.disabled = false;
            addToCartText.textContent = addToCartText.dataset.defaultText || 'Add to cart';
          } else {
            addToCartBtn.disabled = true;
            addToCartText.textContent = 'Sold out';
          }
        }
      }

      if (variantPrice) {
        updateProductPrice(gridItem, variantPrice, variantCompareAtPrice);
      }

      if (variantImage) {
        var mainImage = gridItem.querySelector('.grid__item-image-wrapper img');
        if (mainImage) {
          if (!mainImage.dataset.originalSrc) {
            mainImage.dataset.originalSrc = mainImage.src;
            mainImage.dataset.originalSrcset = mainImage.srcset || '';
          }
          mainImage.style.opacity = '0.5';
          mainImage.onload = function() { mainImage.style.opacity = '1'; };
          mainImage.src = variantImage;
          mainImage.srcset = variantImage;
          if (mainImage.complete) mainImage.style.opacity = '1';
        }
      }
    });

    window.__colorSwatchDesktopHoverBound = true;
  }

  window.openColorSwatchPopup = openColorSwatchPopup;
  window.addToCartViaAPI = addToCartViaAPI;
  window.formatMoneyCollection = formatMoney;

  // После AJAX-фильтрации (collection:reloaded) реинициализируем Opus,
  // чтобы он забиндился к новым формам в DOM.
  if (!window.__opusCollectionReloadBound) {
    document.addEventListener('collection:reloaded', function() {
      // Метод 1: стандартный Opus API
      if (window.OpusCartUpsell && typeof window.OpusCartUpsell.init === 'function') {
        window.OpusCartUpsell.init();
      }
      // Метод 2: некоторые версии Opus слушают кастомное событие
      document.dispatchEvent(new CustomEvent('opus:reinit', { bubbles: true }));
      // Метод 3: Opus иногда слушает page:load / page:change (как Ajax Cart)
      document.dispatchEvent(new CustomEvent('page:load', { bubbles: true }));

      // Метод 4: принудительный ребайнд — находим все новые формы и
      // диспатчим на них событие, которое Opus использует для инициализации.
      document.querySelectorAll('form.collection-product-form[action="/cart/add"]').forEach(function(form) {
        form.dispatchEvent(new CustomEvent('opus:bindForm', { bubbles: true }));
        // Некоторые версии Opus слушают DOMContentLoaded-подобный триггер через MutationObserver,
        // поэтому также трогаем атрибут формы, чтобы спровоцировать наблюдателя.
        form.setAttribute('data-opus-ready', 'true');
      });
    });
    window.__opusCollectionReloadBound = true;
  }

  // ========================================================================
  // "+N" ДЛЯ РЯДА СВОТЧЕЙ — упрощённая, надёжная версия
  // ========================================================================
  // Предыдущая версия пыталась динамически измерять реальную ширину
  // каждого элемента (getBoundingClientRect) и решать, сколько влезает —
  // это оказалось слишком хрупким: !important-классы скрытия конфликтовали
  // с попытками JS их переопределить, давая то "0 показано, +30", то
  // рассинхрон между тем, что видно, и числом на бейдже, то полное
  // исчезновение чисел. Вместо борьбы с этим — полностью доверяем
  // СЕРВЕРНОМУ расчёту (Liquid уже корректно и НАДЁЖНО решает, сколько
  // элементов показать по умолчанию: swatch_limit=7 для цветов,
  // visible_limit для пилюль — тот же принцип, что и раньше был). JS
  // теперь занимается только текстом "+N" (по данным из data-атрибутов,
  // которые Liquid уже посчитал) и переключением всё/свёрнуто на hover —
  // без единого пересчёта размеров.

  function setMoreBadgeText(moreBtn, count) {
    if (!moreBtn) return;
    var n = parseInt(count, 10);
    if (!n || n <= 0) {
      moreBtn.style.display = 'none';
      moreBtn.textContent = '';
      return;
    }
    moreBtn.textContent = '+' + n;
    moreBtn.style.display = '';
  }

  // ВАЖНО: "+N" для pill-опций (.grid-product-option-more) сюда НЕ входит —
  // у него уже есть своя, более функциональная родная система прямо в
  // snippets/variant-button-collection.liquid (свой updateMoreOptionsText(),
  // да ещё и клик по бейджу открывает попап выбора варианта на десктопе
  // и ведёт в карточку товара на мобильном). Два независимых скрипта,
  // управляющие одним и тем же элементом, конфликтовали друг с другом —
  // именно это и приводило к тому, что счётчик на мобильном иногда не
  // показывался. Эта функция теперь отвечает только за цветные свотчи.
  function initMoreBadges() {
    document.querySelectorAll('.color-swatch-more').forEach(function(btn) {
      var total = parseInt(btn.getAttribute('data-total-colors'), 10) || 0;
      var isMobileColors = window.matchMedia('(max-width: 767px)').matches;
      var limit = isMobileColors
        ? (parseInt(btn.getAttribute('data-mobile-swatch-limit'), 10) || 0)
        : (parseInt(btn.getAttribute('data-swatch-limit'), 10) || 0);
      setMoreBadgeText(btn, total - limit);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMoreBadges);
  } else {
    initMoreBadges();
  }
  document.addEventListener('collection:reloaded', initMoreBadges);
  document.addEventListener('shopify:section:load', initMoreBadges);

  var moreBadgeResizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(moreBadgeResizeTimer);
    moreBadgeResizeTimer = setTimeout(initMoreBadges, 150);
  });

  // ── Показать все варианты на hover карточки (десктоп) ────────────────
  // Простое переключение видимости через !important-инлайн-стиль
  // (единственный надёжный способ перебить класс со скрытием, который
  // тоже висит с !important) — без пересчёта размеров, просто show/hide.
  // Оставлено только для цветных свотчей — у pill-опций своя логика
  // hover/клика уже реализована в variant-button-collection.liquid
  // (открывает попап на десктопе), трогать её отсюда не нужно.
  function showAllSwatchesInCard(card) {
    card.querySelectorAll('.color-swatch').forEach(function(el) {
      el.style.setProperty('display', 'inline-block', 'important');
    });
    card.querySelectorAll('.color-swatch-more').forEach(function(btn) {
      btn.style.display = 'none';
    });
    card.querySelectorAll('.grid-product__colors').forEach(function(el) {
      el.style.flexWrap = 'wrap';
    });
  }

  function restoreSwatchLayoutInCard(card) {
    card.querySelectorAll('.color-swatch').forEach(function(el) {
      el.style.removeProperty('display');
    });
    card.querySelectorAll('.grid-product__colors').forEach(function(el) {
      el.style.removeProperty('flex-wrap');
    });
    card.querySelectorAll('.color-swatch-more').forEach(function(btn) {
      var total = parseInt(btn.getAttribute('data-total-colors'), 10) || 0;
      var isMobileColors = window.matchMedia('(max-width: 767px)').matches;
      var limit = isMobileColors
        ? (parseInt(btn.getAttribute('data-mobile-swatch-limit'), 10) || 0)
        : (parseInt(btn.getAttribute('data-swatch-limit'), 10) || 0);
      setMoreBadgeText(btn, total - limit);
    });
  }

  if (!window.__swatchHoverExpandBound) {
    document.addEventListener('mouseenter', function(e) {
      if (window.matchMedia('(max-width: 767px)').matches) return;
      var card = e.target.closest && e.target.closest('.grid__item-collection');
      if (!card) return;
      showAllSwatchesInCard(card);
    }, true);

    document.addEventListener('mouseleave', function(e) {
      var card = e.target.closest && e.target.closest('.grid__item-collection');
      if (!card) return;
      restoreSwatchLayoutInCard(card);
    }, true);

    window.__swatchHoverExpandBound = true;
  }
})();
